























































import {Component, Vue} from "vue-property-decorator";
import FoodService from "@/services/FoodService";

@Component
export default class addIngredient extends Vue {
  private valid: boolean = false;
  private rules: any = {
    required: (value: any) => !!value || 'Required.',
  };
  private loading: boolean = false;
  private description: String = '';
  private descriptionsimple: String = '';
  private quantity: String = '';
  private nutrientsToAdd: any = {};
  private nutrientSelected: any = {};

  get nutrients() {
    return this.$store.getters.getNutrients;
  }

  get nutrientsArray() {
    const nutrientsArray = [];
    for (const id in this.nutrients) {
      if (this.nutrients.hasOwnProperty(id)) {
        nutrientsArray.push({
          id: id,
          name: this.nutrients[id].nutrientname + ' (' + this.nutrients[id].unit + ')'
        });
      }
    }
    return nutrientsArray;
  }

  private addNutrient() {
    if (this.nutrientSelected && this.quantity !== '' && parseInt(this.quantity.toString())) {
      this.nutrientsToAdd[this.nutrientSelected] = {
        id: this.nutrientSelected,
        value: this.quantity,
        name: `${this.nutrients[this.nutrientSelected].nutrientname} (${this.nutrients[this.nutrientSelected].unit})`
      };
      this.nutrientSelected = null;
      this.quantity = '';
    }
  }

  private async createFood() {
    try {
      // @ts-ignore
      if (this.$refs.form.validate()) {
        this.loading = true;
        await FoodService.createFood({
          description: this.description,
          descriptionsimple: this.descriptionsimple
        }, this.nutrientsToAdd);
        this.$emit('close');
      }
    } catch (e) {
      this.$emit('displaySnackbar', e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private removeNutrient(key: string) {
    Vue.delete(this.nutrientsToAdd, key);
  }
}
